import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Spinner from 'UI/Elements/Spinner';
// const { instance, accounts, inProgress } = useMsal();

import auth from 'lib/authentication';
var MyCallbackPage = /*#__PURE__*/function (_Component) {
  function MyCallbackPage() {
    _classCallCheck(this, MyCallbackPage);
    return _callSuper(this, MyCallbackPage, arguments);
  }
  _inherits(MyCallbackPage, _Component);
  return _createClass(MyCallbackPage, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return auth.handleLoginResponse();
            case 1:
              sessionStorage.setItem("justLoggedIn", "true");
              this.props.history.replace('/');
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "loading-page-overview"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    }
  }]);
}(Component);
function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
}
export default withRouter(connect(null, mapDispatchToProps)(MyCallbackPage));